// extracted by mini-css-extract-plugin
export default {"fullWidth":"yn-z","image":"zn-z","lazyLoadPicture":"An-z","lazyLoadSpinner":"Bn-z","lazyLoadSpin":"Cn-z","lazyLoadImage":"Dn-z","hasStyledAspectRatio":"En-z"};